import Glide, { Controls, Autoplay, Swipe } from '@glidejs/glide/dist/glide.modular.esm'

const carousels = document.querySelectorAll('.carousel')

carousels.forEach(carousel => {

  var itemsToShow = parseInt(carousel.dataset.perViewTouch);
  // These alterations only apply to people
  // carousel on expertise grand children pages
  if(carousel.dataset.viewType == 'person'){

    // Cards per mobile device 
    if(screen.width < 767) {
      itemsToShow = 1;
    } else if(screen.width < 980) {
      itemsToShow = 2;
    }

  }

  if(carousel.dataset.viewType == 'award'){

    // Cards per mobile device 
    if(screen.width < 767) {
      itemsToShow = 2;
    } else if(screen.width < 980) {
      itemsToShow = 3;
    }

  }

  const count = carousel.querySelectorAll('ul > li').length,
    perView = parseInt(carousel.dataset.perView) || 1,
    perViewTouch = itemsToShow

  // Count pages for mobile devices
  var pageCount = Math.ceil(count / perView)

  if(carousel.dataset.viewType == 'person'){

    // pages per mobile device 
    if(screen.width < 767) {
      pageCount = Math.ceil(count / itemsToShow)
    } else if(screen.width < 980) {
      pageCount = Math.ceil(count / itemsToShow)
    }

  }

  if(carousel.dataset.viewType == 'award'){

    // pages per mobile device 
    if(screen.width < 767) {
      pageCount = Math.ceil(count / itemsToShow)
    } else if(screen.width < 980) {
      pageCount = Math.ceil(count / itemsToShow)
    }

  }
  // End count pages for mobile devices


  const pages = pageCount,
    pauseOnInit = carousel.dataset.pauseOnInit || false,
    autoplay = carousel.dataset.autoplay

    
  let glide = new Glide(carousel, {
    type: 'carousel',
    //startAt: 0,
    autoplay: pages > 1 ? 8000 : false,
    gap: 30,
    perView: screen.width < 980 ? perViewTouch : perView,
    breakpoints: {
      980: {
        perView: 2 // TODO this is not working, glide bug?
      },
      500: {
        perView: 1
      }
    }
  })

  glide.mount(pages > 1 ? { Controls, Autoplay, Swipe } : null)

  if (pauseOnInit) {
    glide.pause()
  }

  if(!autoplay) {
    glide.pause()
  }

  if (typeof window.glide === 'undefined') {
    window.glide = []
  }

  window.glide.push(glide)
})




// WEBPACK FOOTER //
// ./scripts/lib/carousels.js